import { queryOptions } from '@tanstack/react-query';
import type { HevitonApiAppLegacy } from '@heviton/heviton-api-app-legacy';
import { STALE_TIME } from '@/shared/api';
import { mapPlantsWithDevices } from '@/shared/data-mappers';
import type { PlantWithDevices } from '@/shared/data-types';

/**
 * 발전소 + 설비 목록 query 정의 SSOT — 알림·인버터 필터의 발전소/설비 select 용. BE = app-legacy(v3)
 * `GET /plants` (inverters·rtus 응답 기본 포함, include 불필요 — RN 앱 정합). 세션 중 거의 안 변함 →
 * `staleTime: STATIC`.
 */
export const PLANTS_WITH_DEVICES_QUERY_KEY = ['plants', 'with-devices'] as const;

export const plantsWithDevicesQueryOptions = (api: HevitonApiAppLegacy) =>
  queryOptions<PlantWithDevices[]>({
    queryKey: PLANTS_WITH_DEVICES_QUERY_KEY,
    queryFn: async ({ signal }) => {
      const raw = await api.plant.list(undefined, { signal });
      return mapPlantsWithDevices(raw);
    },
    staleTime: STALE_TIME.DEFAULT,
  });
